/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgExclamationSign = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.442 1.95h-.885l-6 11.342.443.733h12l.442-.732-6-11.343zM2.827 13.025L8 3.25l5.172 9.775H2.827z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.48 6.63h-1v3.44h1V6.63zM8.48 10.727h-1v1.146h1v-1.146z"
}));

export default SvgExclamationSign;